export default "__VITE_ASSET__bc0b91f3__"